"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var calculators_1 = require("./calculators");
var PopoverContext_1 = require("./PopoverContext");
exports.usePortalDOMNodeRef = function (zIndex) {
    var portalDOMNodeRef = react_1.useRef(null);
    var popoverViewContext = react_1.useContext(PopoverContext_1.PopoverContext);
    if (!portalDOMNodeRef.current) {
        portalDOMNodeRef.current = popoverViewContext.getPortalDOMNode(zIndex);
    }
    return portalDOMNodeRef;
};
var calculatePosition = function (_a) {
    var preset = _a.preset, targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition;
    var offset = { left: preset.offsetX || 0, top: preset.offsetY || 0 };
    return {
        left: calculators_1.OFFSET_CALCULATORS.x[preset.xAxis]({
            targetRect: targetRect,
            popoverRect: popoverRect,
            portalPosition: portalPosition,
            offset: offset
        }),
        top: calculators_1.OFFSET_CALCULATORS.y[preset.yAxis]({ targetRect: targetRect, popoverRect: popoverRect, portalPosition: portalPosition, offset: offset })
    };
};
exports.getWindowSize = function () {
    return {
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
};
exports.selectBestPreset = function (_a) {
    var presets = _a.presets, targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, viewportAccuracyFactor = _a.viewportAccuracyFactor, windowSize = _a.windowSize;
    var resultPreset = presets[0];
    var bestViewportAccuracyFactor = 0;
    if (typeof window !== 'undefined' && presets.length > 1) {
        var windowWidth_1 = windowSize.width;
        var windowHeight_1 = windowSize.height;
        presets.some(function (preset) {
            var position = calculatePosition({ preset: preset, targetRect: targetRect, popoverRect: popoverRect, portalPosition: portalPosition });
            var rect = Object.assign({ width: popoverRect.width, height: popoverRect.height }, position);
            var left = Math.max(rect.left, 0);
            var right = Math.min(rect.left + rect.width, windowWidth_1);
            var top = Math.max(rect.top, 0);
            var bottom = Math.min(rect.top + rect.height, windowHeight_1);
            var rectArea = rect.width * rect.height;
            var visibleRectArea = (right - left) * (bottom - top);
            var currentViewportAccuracyFactor = visibleRectArea / rectArea;
            if (currentViewportAccuracyFactor >= viewportAccuracyFactor) {
                resultPreset = preset;
                return true;
            }
            if (currentViewportAccuracyFactor > bestViewportAccuracyFactor) {
                bestViewportAccuracyFactor = currentViewportAccuracyFactor;
                resultPreset = preset;
            }
            return false;
        });
    }
    return resultPreset;
};
var POSITION_STYLE;
(function (POSITION_STYLE) {
    POSITION_STYLE["absolute"] = "absolute";
})(POSITION_STYLE || (POSITION_STYLE = {}));
var VISIBILITY_STYLE;
(function (VISIBILITY_STYLE) {
    VISIBILITY_STYLE["hidden"] = "hidden";
    VISIBILITY_STYLE["visible"] = "visible";
})(VISIBILITY_STYLE || (VISIBILITY_STYLE = {}));
exports.calculateStyle = function (_a) {
    var preset = _a.preset, targetRect = _a.targetRect, popoverRect = _a.popoverRect, portalPosition = _a.portalPosition, offset = _a.offset;
    var style = {
        position: POSITION_STYLE.absolute,
        visibility: VISIBILITY_STYLE.hidden
    };
    if (!preset || !popoverRect) {
        return style;
    }
    var xOffsetCalculator = calculators_1.OFFSET_CALCULATORS.x[preset.xAxis];
    var yOffsetCalculator = calculators_1.OFFSET_CALCULATORS.y[preset.yAxis];
    var position = {
        left: xOffsetCalculator({ targetRect: targetRect, popoverRect: popoverRect, portalPosition: portalPosition, offset: offset }) + "px",
        top: yOffsetCalculator({ targetRect: targetRect, popoverRect: popoverRect, portalPosition: portalPosition, offset: offset }) + "px"
    };
    return __assign(__assign(__assign({}, style), position), { visibility: VISIBILITY_STYLE.visible });
};
//# sourceMappingURL=helpers.js.map